import jagaimo from "../../assets/projects/jagaimo.png";
import satvs from "../../assets/projects/satvs.png";
import wiljo from "../../assets/projects/wiljo.png";
import avag from "../../assets/projects/avag.png";
import UEC_IW from "../../assets/projects/uec_IW.png"

import mexico from "../../assets/flags/mexico.png";
import japan from "../../assets/flags/japan.png";
import usa from "../../assets/flags/usa.png";

import javascript from "../../assets/skills/languages/js.png";
import react from "../../assets/skills/web/react.svg";
import html from "../../assets/skills/web/html.svg";
import css from "../../assets/skills/web/css.svg";

import TechCarousel from "../../components/techCarousel/TechCarousel";
import { ProjectCard } from "../../components";
import { Timeline } from "../../containers";


import "./experience.css";

const experiences = [
    {
        title: "Research Assistant",
        company: "The University of Electro-Communications",
        location: "Tokyo, Japan",
        period: "Apr 2026 – Present",
        points: [
            "Guide and support students in computer vision and deep learning research projects, helping them define objectives, structure experiments, and improve technical implementation.",
            "Assist in coordinating collaborative research activities, including project planning, progress discussions, experiment organization, and academic writing.",
            "Provide mentorship to students with different backgrounds and skill levels, supporting their development in research methodology, coding practices, and result analysis.",
            "Contribute to large-scale research workflows by combining technical development, team guidance, experimental evaluation, and publication preparation.",
    ],
    },
    {
        title: "PhD Student",
        company: "The University of Electro-Communications",
        location: "Tokyo, Japan",
        period: "Oct 2024 – Present",
        points: [
            "Research efficient graph-based deep learning methods for 3D human pose estimation.",
            "Design lightweight neural network architectures focused on accuracy and computational efficiency.",
            "Evaluate models using standard 3D human pose estimation protocols and datasets.",
    ],
    },
    {
        title: "Generative AI Consultant",
        company: "Running With Scissors",
        location: "Tucson, AZ, USA",
        period: "Oct 2023 – Sept 2024",
        points: [
            "Designed and trained Stable Diffusion models to generate visual references for the art and design team, supporting concept exploration and creative ideation.",
            "Collaborated closely with artists to align generated outputs with the studio’s established visual style across ongoing video game projects.",
            "Fine-tuned generative models on curated art references to produce style-consistent inspiration assets, accelerating the concept art pipeline.",
    ],
    },
    {
        title: "Master's Researcher",
        company: "The University of Electro-Communications & National Polytechnic Institute of Mexico",
        location: "Japan & Mexico",
        period: "Oct 2022 – Oct 2023",
        points: [
            "Worked on spatio-temporal hand gesture localization and recognition.",
            "Designed deep learning models using computer vision techniques.",
            "Presented research results at international academic events.",
        ],
    },
    {
        title: "Web Developer",
        company: "Freelance / Client Projects",
        location: "Mexico, Japan, United States",
        period: "Jan 2020 – Present",
        points: [
            "Develop responsive websites using HTML, CSS, JavaScript, and React.",
            "Create client-focused project pages with modern UI components and interactive sections.",
            "Deploy and maintain production websites for companies across different countries.",
    ],
    },
    ];

    export default function Projects() {
    return (
    <div className="Portafolio__Experience" id="experience">
        <div className="glitch_section" data-text="Experience">Experience</div>

        <div className="timeline">
            <Timeline experiences={experiences} />
        </div>

        <div className="carousel">
            <TechCarousel />
        </div>

        <section className="projects-section">

            <div className="glitch_section" data-text="Web Projects">Web Projects</div>

            <ProjectCard
                title="UEC International Week 2026"
                description="Official event website for UEC International Week 2026, designed to present schedules, activities, and international programs in a clear and accessible format for students, guests, and university visitors."
                image={UEC_IW}
                imageAlt="UEC International Week 2026 project preview"
                countryFlag={japan}
                countryName="Japan"
                tools={[
                    { name: "HTML", icon: html },
                    { name: "CSS", icon: css },
                    { name: "JavaScript", icon: javascript },
                ]}
                projectUrl="https://www.uec.ac.jp/international_week/"
                layout="wide"
            />

            <ProjectCard
                title="WILJO Vending"
                description="Business website for a U.S.-based full-service vending company, showcasing arcade machines, pool tables, jukeboxes, ATMs, and entertainment services for bars, restaurants, and commercial venues."
                image={wiljo}
                imageAlt="WILJO Vending project preview"
                countryFlag={usa}
                countryName="United States"
                tools={[
                    { name: "HTML", icon: html },
                    { name: "CSS", icon: css },
                    { name: "JavaScript", icon: javascript },
                    { name: "React", icon: react },
                ]}
                projectUrl="https://wiljovending.com/"
                layout="reverse"
            />

            <ProjectCard
                title="Jagaimo Club"
                description="Website for a long-standing Japanese club founded in 1954, presenting its history, activities, and official information through a clean and structured digital platform."
                image={jagaimo}
                imageAlt="Jagaimo Club project preview"
                countryFlag={japan}
                countryName="Japan"
                tools={[
                    { name: "HTML", icon: html },
                    { name: "CSS", icon: css },
                    { name: "JavaScript", icon: javascript },
                ]}
                projectUrl="http://www.jc-jagaimoclub.jp/index.html"
                layout="wide"
            />

            <ProjectCard
                title="Satvs"
                description="Website for a premium residential project in Mexico, highlighting architectural design, spatial distribution, and the surrounding natural environment through a warm and visually focused presentation."
                image={satvs}
                imageAlt="Satvs project preview"
                countryFlag={mexico}
                countryName="Mexico"
                tools={[
                    { name: "HTML", icon: html },
                    { name: "CSS", icon: css },
                    { name: "JavaScript", icon: javascript },
                ]}
                projectUrl="https://luisestebanacevedobringas.github.io/SATUS-CSL/"
                layout="reverse"
            />

            <ProjectCard
                title="AVAG | IC"
                description="Corporate website for a Mexican construction company, designed to communicate its values, services, and project expertise with a professional and trustworthy digital presence."
                image={avag}
                imageAlt="AVAG | IC project preview"
                countryFlag={mexico}
                countryName="Mexico"
                tools={[
                    { name: "HTML", icon: html },
                    { name: "CSS", icon: css },
                    { name: "JavaScript", icon: javascript },
                ]}
                projectUrl="https://www.avagic.com/"
                layout="wide"
            />

            {/* <ProjectCard
                title="Takahashi Laboratory"
                description="AI coworker that connects to tools like email, calendar, Slack, docs, and project systems to help teams reduce busywork"
                image={avag}
                imageAlt="Takahashi Laboratory project preview"
                countryFlag={japan}
                countryName="Japan"
                tools={[
                { name: "HTML", icon: html },
                { name: "CSS", icon: css },
                { name: "JavaScript", icon: javascript },
                { name: "React", icon: react },
                ]}
                projectUrl="/projects/dimension-ai"
                layout="reverse"
            /> */}
        </section>

    </div>
    );
}